/** Route of the full privacy policy. Public: readable without an account. */
export const PRIVACY_POLICY_PATH = "/privacy";

/**
 * Data-storage disclaimer shown in the page footer, on the assessment review
 * step, on the results sign-in gate, and under the signup form. Single source so
 * legal can tune the wording in one place. Render `<DataStorageNotice />`
 * (components/data-storage-notice.tsx) rather than this string directly: it
 * appends the link to the full policy.
 *
 * Every claim here must be true of the code as it stands:
 *  - "not sent to any third-party AI provider" holds only while the prefill
 *    analyzer stays heuristic (backend `prefill/analyze.py`, no LLM, and no
 *    AI-provider SDK in `backend/pyproject.toml`). Wiring up a real model means
 *    rewriting this sentence and the policy before the integration ships.
 *  - There is deliberately no "to improve the index" clause: no code path uses
 *    assessment data to train or tune anything, so it would be a false
 *    statement. The policy says the same, in the negative. Adding that secondary
 *    use means writing the code first, then both texts.
 */
export const DATA_STORAGE_NOTICE =
  "Board of Innovation stores your account details and assessment responses to generate your report and let you revisit it. Your responses are not sent to any third-party AI provider.";
